import React, { useEffect, useState } from "react";
import ToggleSwitch from "./input-elements/ToggleSwitch";
import { Grid } from "@mui/material";
import RoundedCheckBox from "./input-elements/RoundedCheckBox";

export default function PaychexOptions({
    setFormDataByKeyValue,
    errors,
    form_data,
    setErrors,
    all_equipment_list,
}) {
    const [equipment_options, setEquipmentOptions] = useState([]);

    const onChangeToggle = (value) => {
        setFormDataByKeyValue("var_sheet_request", value);
    };

    useEffect(() => {
        setFormDataByKeyValue("is_tm", "no");
        let eqp_ops = all_equipment_list.map((item) => ({
            label: item.equipment_name,
            value: item.equipment_slug,
        }));
        setEquipmentOptions(eqp_ops);
    }, [all_equipment_list]);

    return <div className="merchant-referral"></div>;
}
